export enum AnalysisSubStep {
  Selection = "Selection",
  Analysis = "Analysis",
}
